import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import IconDelete from "../../../../layout/others/icon-x.svg";
import Select from "../../../../components/Select";

export default function Availability({
  searchObject,
  setSearchObject,
  onChange,
  t
}) {
  const [avaibilities, setAvaibilities] = useState([]);
  const [noticeTimeOptions, setNoticeTimeOptions] = useState([]);
  function onchangeAvailability({ target }) {
    if (target.checked)
      setSearchObject({
        ...searchObject,
        availabilityStatusId: Number(target.value)
      });
  }

  function clearAvailability() {
    let _searchObject = { ...searchObject };
    _searchObject.availabilityStatusId = undefined;
    _searchObject.noticeId = undefined;

    setSearchObject(_searchObject);
  }

  useEffect(() => {
    CommonService.getAvailabilities().then((data) => setAvaibilities(data));
    CommonService.getNoticeOptions().then((data) => setNoticeTimeOptions(data));
  }, []);

  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Availability")}</legend>
        {searchObject.availabilityStatusId !== 0 &&
          searchObject.availabilityStatusId !== undefined && (
            <button
              onClick={clearAvailability}
              className="btn-clear-availability"
            >
              <img
                src={IconDelete}
                alt="ico-ppl"
                height="12px"
                width="auto"
                style={{ height: "14px" }}
              />
              <a className="clear-button">{t("Clear")}</a>
            </button>
          )}
        <div>
          {avaibilities.map((avail) => (
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="availabilityStatusId"
                value={avail.id}
                id={t(avail.description)}
                checked={searchObject.availabilityStatusId === avail.id}
                onChange={onchangeAvailability}
              />
              <label
                className="form-check-label fontsize-legend"
                for={avail.description}
              >
                {t(avail.description)}
              </label>
            </div>
          ))}
        </div>
        {searchObject.availabilityStatusId === 3 && (
          <div className="position-dropdown-availability">
            <Select
              className="form-select fontsize-legend"
              onChange={onChange}
              name="noticeId"
              id="noticeId"
              value={searchObject.noticeId || ""}
            >
              <option className="fontsize-legend" key={0} value="" selected>
                {t("Avaibility...")}
              </option>
              {noticeTimeOptions.map((notice) => (
                <option
                  className="fontsize-legend"
                  value={notice.id}
                  key={notice.id}
                >
                  {t(notice.description)}
                </option>
              ))}
            </Select>
          </div>
        )}
      </div>
    </>
  );
}
